module.exports = __webpack_public_path__ + "media/images/cplook/apple-touch-icon-120x120-9e4ee28269207101d492f2dffaeeae54.png";